module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/HowToBackground-c9351235edd35ec050e62de195e130c4.webp";